module.exports = __webpack_public_path__ + "img/alelo.svg";